import { components } from "@/@types/api";

import { DefaultCategoryValue, DefaultProductValue } from "./constants";

export type BCPNode = {
  brand: string;
  category: string;
  product: string;
};

export const bcpLayerKey = ({ brand, category, product }: BCPNode) => {
  return `${brand}-${category}-${product}`;
};

type ScenarioResultRevenue = components["schemas"]["ScenarioResultRevenue"];

export const getBCPFromRevenues = (revenues: ScenarioResultRevenue[]) => {
  const bcpMap = new Map<string, BCPNode>();

  for (const revenue of revenues) {
    const bcp = {
      brand: revenue.saleBrand,
      category: revenue.saleCategory,
      product: revenue.saleProduct,
    };

    const key = bcpLayerKey(bcp);
    if (!bcpMap.has(key)) {
      bcpMap.set(key, bcp);
    }
  }

  return Array.from(bcpMap.values());
};

export const getUniqueBrandsAndCategories = (bcps: BCPNode[]) => {
  const brands = new Set<string>(bcps.map((bcp) => bcp.brand));

  const categories = new Map<string, { brand: string; category: string }>();

  for (const bcp of bcps) {
    const key = `${bcp.brand}-${bcp.category}`;
    if (!categories.has(key)) {
      categories.set(key, {
        brand: bcp.brand,
        category: bcp.category,
      });
    }
  }
  return { brands, categories };
};

export const getBusinessUnitName = (bcp: BCPNode) => {
  if (bcp.product !== DefaultProductValue) {
    return `${bcp.brand} > ${bcp.category} > ${bcp.product}`;
  }

  if (bcp.category !== DefaultCategoryValue) {
    return `${bcp.brand} > ${bcp.category}`;
  }

  return bcp.brand;
};

type FunnelStage = "brand" | "category" | "product";

export const getFunnelStage = (bcp: BCPNode): FunnelStage => {
  if (bcp.product !== DefaultProductValue) {
    return "product";
  }

  if (bcp.category !== DefaultCategoryValue) {
    return "category";
  }

  return "brand";
};
